export function rememberSummaryEntry() {
  localStorage.setItem("summaryEntry", location.href);
}

export function recallSummaryEntry() {
  if (localStorage.getItem("summaryEntry")) {
    return new URL(localStorage.getItem("summaryEntry"));
  }

  return null;
}
